import { GenericHeader, SearchBar } from 'components';
import ListComp from 'components/ListComp';
import React from 'react';
import { Wallet } from 'services';
import { Results } from './components';
const AccountWallets = props => {
  let { account } = props;
  const Head = props => {
    let { handleCreateOpen, ...rest } = props; // eslint-disable-line
    if (account) return (
      <GenericHeader subheader={`Wallets for ${account.displayname}`} >
      </GenericHeader>
    );
    return (
      <GenericHeader header="All Wallets" subheader="Wallet Management" {...rest} />
    );
  }

  return (
    <ListComp
      listing={Wallet.list}
      title="Wallets"
      name="wallets"
      SearchBar={SearchBar}
      Header={Head}
      Results={Results}
      // CreateComp={CreateModal}
      filters={{ limit: 10, offset: 0, count: 0, search: "", account: account ? account.id : null }}
    />
  );
};

export default AccountWallets;
